import { Filter } from "@/models";

export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const PRIVATE_KEY = process.env.NEXT_PUBLIC_PRIVATE_KEY;
export const BRAND_IMG = "/logo.png";

export const BRAND_NAME: string = "ECG Transactions";
export const BRAND_TAGLINE: string = " ";
export const BRAND_DESCRIPTION: string = " ";
export const BRAND_URL: string = "https://ecg-transactions.gov-gh.com/";

export const powerAppTransactionFilters: Filter[] = [
  { name: "PhoneNumber", text: "Phone Number", elementType: "text" },
  { name: "AccountNumber", text: "Account Number", elementType: "text" },
  { name: "MeterNumber", text: "Meter Number", elementType: "text" },
  { name: "MeterType", text: "Meter Type", elementType: "text" },
  { name: "MeterCategory", text: "Meter Category", elementType: "text" },
  { name: "GhanaCardId", text: "Ghana Card ID", elementType: "text" },
  { name: "Status", text: "Status", elementType: "text" },
];

export const oltpvTopupsFilters: Filter[] = [
  { name: "AccountNumber", text: "Account Number", elementType: "text" },
  { name: "VendorAccountId", text: "Vendor Account ID", elementType: "text" },
  { name: "Email", text: "Email", elementType: "text" },
  { name: "GovInvoiceNumber", text: "Gov Invoice Number", elementType: "text" },
  { name: "Status", text: "Status", elementType: "text" },
  {
    name: "",
    text: "Date",
    elementType: "date-range",
    options: [
      {
        label: "Start Date",
        value: "StartDate",
      },
      {
        label: "End Date",
        value: "EndDate",
      },
    ],
  },
];
